import { createActionGroup, props } from '@ngrx/store';
import { Pagination } from '@shared/models/pagination.model';

import {
  StockPackingHistoryListContent,
  StockPackingHistorySearchCriteria
} from '../../model/stock-packing-history.model';

export const StockPackingHistoryAction = createActionGroup({
  source: 'Stock Packing History',
  events: {
    RequestList: props<{ criteriaObj: StockPackingHistorySearchCriteria }>(),
    ResponseList: props<{
      data: Pagination<StockPackingHistoryListContent>;
    }>()
  }
});
